import { Link, useLocation } from "react-router-dom";
import { useEffect } from "react";
import dd from "../../assets/DD.png";

const MobileDropdown = ({
  title,
  isOpen,
  setIsOpen,
  handleLinkClick,
}) => {

  const location = useLocation();


  const isProductActive = location.pathname.startsWith("/products");

  useEffect(() => {
    if (isProductActive) {
      setIsOpen(true);
    }
  }, [location.pathname]);

  return (
    <div className="w-full">


      <div
        className={`flex items-center justify-center gap-2 py-3  text-lg cursor-pointer transition ${isProductActive ? "text-[#FF7A00]" : "text-black"
          } hover:text-[#FF7A00]`}
        onClick={() => setIsOpen(!isOpen)}
      >
        {title}
        <img
          src={dd}
          alt="arrow"
          className={`h-3 w-3 transition-transform duration-300 ${isOpen ? "rotate-180" : ""
            }`}
        />
      </div>


      {isOpen && (
        <div className="bg-gray-50 rounded-xl p-6 space-y-6">

          <h3 className="text-sm text-gray-500 font-semibold text-center">
            Modules in Solutions
          </h3>

          <Link
            to="/products/healthcare"
            onClick={handleLinkClick}
            className={`block text-center border-b pb-4 transition cursor-pointer ${location.pathname === "/products/healthcare"
                ? "text-[#FF7A00]"
                : ""
              }`}
          >
            <h3 className="text-xs text-gray-500 uppercase mb-2">
              LIMS
            </h3>

            <p className="text-base font-semibold">
              Laboratory Information Management System (LIMS / WinLIMS)
            </p>

            <p className="text-sm text-gray-500 mt-1">
              For standalone labs, hospital labs, and lab chains
            </p>
          </Link>


          <Link
            to="/products/quality-management-system"
            onClick={handleLinkClick}
            className={`block text-center border-b pb-4 transition cursor-pointer ${location.pathname === "/products/quality-management-system"
                ? "text-[#FF7A00]"
                : ""
              }`}
          >
            <h3 className="text-xs text-gray-500 uppercase mb-2">
              QMS
            </h3>

            <p className="text-base font-semibold">
              Quality Control System (QMS)
            </p>

            <p className="text-sm text-gray-500 mt-1">
              Manages QC processes, audits, and compliance
            </p>
          </Link>


          <Link
            to="/products/inventory"
            onClick={handleLinkClick}
            className={`block text-center border-b pb-4 transition cursor-pointer ${location.pathname === "/products/inventory"
                ? "text-[#FF7A00]"
                : ""
              }`}
          >
            <h3 className="text-xs text-gray-500 uppercase mb-2">
              Inventory
            </h3>

            <p className="text-base font-semibold">
              Inventory Management System
            </p>

            <p className="text-sm text-gray-500 mt-1">
              Tracks lab consumables, suppliers, and stock
            </p>
          </Link>


          <Link
            to="/products/veterinary"
            onClick={handleLinkClick}
            className={`block text-center transition cursor-pointer ${location.pathname === "/products/veterinary"
                ? "text-[#FF7A00]"
                : ""
              }`}
          >
            <h3 className="text-xs text-gray-500 uppercase mb-2">
              Veterinary
            </h3>

            <p className="text-base font-semibold">
              Veterinary LIMS
            </p>

            <p className="text-sm text-gray-500 mt-1">
              Specialized system for veterinary laboratories
            </p>
          </Link>

        </div>
      )}
    </div>
  );
};

export default MobileDropdown;